<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper p-0" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton rounded-none"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="
            sm:inline-flex
            xl:hidden
            cursor-pointer
            p-2
            mobile-menu-toggler
          "
          :icon="['far', 'bars']"
          @click.stop="showSidebar"
        />
        <search-bar />

        <vs-button
          class="mr-4 navbar-button"
          type="flat"
          icon="fa-plus"
          icon-pack="fas"
          :to="{ name: 'job_project.create' }"
          >Stellenangebot</vs-button
        >

        <vs-button
          class="mr-4 navbar-button"
          type="flat"
          icon="fa-plus"
          icon-pack="fas"
          :to="{ name: 'applicant.create' }"
          >Bewerber</vs-button
        >

        <vs-button
          v-if="$store.getters['user/hasPermission']('bi')"
          class="mr-4 navbar-button"
          type="flat"
          icon="fa-plus"
          icon-pack="fas"
          :to="{ name: 'bi.campaigns.create' }"
          >Kampagne</vs-button
        >

        <vs-button
          v-if="$store.getters['user/hasPermission']('matcher')"
          class="mr-4 navbar-button"
          type="flat"
          icon="fa-plus"
          icon-pack="fas"
          :to="{ name: 'request.create' }"
          >Anfrage</vs-button
        >

        <vs-spacer />

        <notification-drop-down />

        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";

export default {
  name: "TheNavbarVertical",
  components: {
    SearchBar,
    NotificationDropDown,
    ProfileDropDown
  },
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.theme !== "dark")
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
      return "navbar-default";
    }
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    }
  }
};
</script>
